<template>
  <div v-if="isUserConcent" class="detector">
    <video autoplay id="video" ref="videoElement" v-show="!isStopped"></video>
    <div v-if="isLoading">Loading. Please wait</div>
    <div v-else-if="!isLoaded">
      Failed to load. Guess you have to filter it by yourself
    </div>
    <div v-else @click="toggleStart">
      <div v-if="isStopped">Start</div>
      <div v-else>Stop</div>
    </div>
    <div v-if="result">
      {{ Math.ceil(result.age) }}
    </div>
  </div>
  <div v-else class="detector" @click="startWebcam">
    Let us suggest. Click to start webcam
  </div>
</template>

<script>
import * as faceapi from "face-api.js";

async function delay(time) {
  return new Promise(res => {
    setTimeout(() => {
      res();
    }, time);
  });
}

export default {
  props: ["threshold"],
  data() {
    return {
      isUserConcent: false,
      isLoading: false,
      isLoaded: false,
      result: null,
      isStopped: false,
      stream: null
    };
  },
  methods: {
    async loadModel() {
      this.isLoading = true;
      await faceapi.nets.tinyFaceDetector.loadFromUri("/model");
      // await faceapi.nets.ssdMobilenetv1.loadFromUri("/model");
      await faceapi.nets.faceLandmark68Net.loadFromUri("/model");
      await faceapi.nets.ageGenderNet.loadFromUri("/model");
      this.open();
    },
    async predict() {
      if (!this.isLoaded) {
        return;
      }
      const input = this.$refs.videoElement;
      const result = await faceapi
        .detectSingleFace(input, new faceapi.TinyFaceDetectorOptions())
        .withFaceLandmarks()
        .withAgeAndGender();
      this.result = result;
      if (result && result.genderProbability > 0.65) {
        this.$emit("detected", result);

        if (result.genderProbability > this.threshold) {
          this.toggleStart();
        }
      }
    },
    async startWebcam() {
      this.isUserConcent = true;
      await this.loadModel();
      await this.predictInterval();
    },
    async predictInterval() {
      while (!this.isStopped) {
        await this.predict();
        await delay(1000);
      }
    },
    toggleStart() {
      this.isStopped = !this.isStopped;
      if (this.isStopped) {
        this.close();
      } else {
        this.open();
      }
    },
    close() {
      this.stream.getTracks()[0].stop();
    },
    open() {
      const video = this.$refs.videoElement;
      const that = this;
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then(function(stream) {
          video.srcObject = stream;
          that.stream = stream;
          that.isLoaded = true;
        });
      this.isLoading = false;
      this.result = null;
      this.predictInterval();
    }
  }
};
</script>

<style lang="scss" scoped>
.detector {
  text-align: center;
}
#video {
  width: 100%;
  background-color: #f7f7f7;
}
</style>
